
import React from "react";
import ReactModal from "react-modal";
import ReactLoading from 'react-loading';

function Started({ postStarted, setPostStarted }) {
    
    return(
        <ReactModal
            isOpen = { postStarted }
            onRequestClose = { () => setPostStarted(false) }
            style = {{
                overlay: {
                    position: 'fixed',
                    top: 0,
                    left: 0,
                    right: 0,
                    bottom: 0,
                    backgroundColor: 'rgba(0, 0, 0, 0.3)',
                    zIndex: 300,
                },
                content: {
                    width: "90%",
                    top: "5px",
                    maxWidth: '500px',
                    maxHeight: "150px",
                    height: "85vh",
                    border: 'none',
                    margin: "auto",
                    left: "5%",
                    borderRadius: "10px",
                    background: 'white',
                    WebkitOverflowScrolling: 'touch',
                    outline: 'none',
                    boxShadow: "0 0 10px rgba(0,0,0,0.3)",
                    overflowY: "auto",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center"
                }
            }}
        >
            <h3 
                style = {{
                    margin: "0 0px 20px 0", 
                    fontSize: "40px", 
                    color: "darkred", 
                    fontWeight: "700", 
                    fontFamily: "Verdana"
                }}
            >
                Posting
            </h3>
            <ReactLoading 
                type = { "balls" }
                color = { "darkred" }
                height = { 40 }
                width = { 40 }
            />
        </ReactModal>
    )
}

export default Started
